import { SecondaryOrderBlotter } from './SecondaryOrderBlotter';
import { connectSecondaryMarketOrderBlotter } from './SecondaryOrderBlotter.connect';

export const ConnectedSecondaryMarketOrderBlotter = connectSecondaryMarketOrderBlotter(SecondaryOrderBlotter);
